import Text from "consumer/custom/text";

export default function Fleid(props) {
	const fieldList = props["fieldList"];

	return fieldList.map((value, index) => {
		if (value["type"] === "short_text") {
			return (
				<Text
					key={index}
					label={value["label"]}
					name={`field_${value["id"]}`}
					error={`${value["label"]} 입력해 주세요.`}
					required={value["required"]}
					attributes={value["attributes"]}
				></Text>
			);
		} else if (value["type"] === "long_text") {
			return <div></div>;
		}
	});
}
